export const badgeSizes = {
	lg: 'lg',
};
